import React, { useState } from 'react';

import InstallPWAButton from '@/components/client-hub/InstallPWAButton';
import ClientHubContactWebform from '@/components/client-hub/sections/contact-webform';
import convertTimeFormat from '@/helper/convertTimeFormat';
import chevronDown from '@/public/images/icons/chevron-down.svg';

const ClientHubContact = (props: {
  isMobile: boolean;
  activeSection: string;
  track: Function;
  facilityData: any;
}) => {
  const { isMobile, activeSection, track, facilityData } = props;

  const id = 'contact';

  const Address = facilityData?.Address;

  const [expandOfficeHours, setExpandOfficeHours] = useState(false);
  const officeHours = (
    dayOfWeek:
      | 'Monday'
      | 'Tuesday'
      | 'Wednesday'
      | 'Thursday'
      | 'Friday'
      | 'Saturday'
      | 'Sunday'
  ) => {
    return convertTimeFormat(facilityData.Store_Hours[dayOfWeek], 'en');
  };

  const [expandGateHours, setExpandGateHours] = useState(false);
  const gateHours = (
    dayOfWeek:
      | 'Monday'
      | 'Tuesday'
      | 'Wednesday'
      | 'Thursday'
      | 'Friday'
      | 'Saturday'
      | 'Sunday'
  ) => {
    return convertTimeFormat(facilityData.Open_Hours[dayOfWeek], 'en');
  };

  const showSection = () => {
    if (isMobile) return activeSection === id;
    return true;
  };

  const [showWebForm, setShowWebForm] = useState(false);

  const toggleWebForm = () => {
    if (!showWebForm) track('Expand contact web form');
    setShowWebForm(!showWebForm);
  };
  if (!facilityData) return null;

  return (
    <div style={{ display: showSection() ? 'block' : 'none' }}>
      <div style={{ marginBottom: '30px' }}>
        We are excited to welcome you to{' '}
        <b>Access Storage – {facilityData?.Title || ''}</b>. Here you can find
        everything you need to get started.
      </div>
      {isMobile && (
        <div style={{ marginBottom: '30px' }}>
          <div onClick={() => track('Install app')}>
            <InstallPWAButton />
          </div>
        </div>
      )}
      <h3
        id="contact"
        style={{ textTransform: 'none', backgroundColor: 'aliceblue' }}
      >
        Contact us
      </h3>
      <div>
        We are here to support you at every step.
        <br />
        <br />
        <div>
          <b>
            By phone:{' '}
            <a
              style={{ textDecoration: 'none' }}
              onClick={() => track('Call store')}
              href={`tel:${facilityData?.Support?.Phone_Number}`}
            >
              {facilityData?.Support?.Phone_Number}
            </a>
          </b>
        </div>
        <div
          onClick={() => toggleWebForm()}
          style={{ padding: '20px 0 10px 0' }}
        >
          <b>
            By{' '}
            <a
              style={{ textDecoration: 'none' }}
              onClick={(e) => {
                e.preventDefault();
                return false;
              }}
              href="#"
            >
              {' '}
              web form
            </a>{' '}
            <img
              src={chevronDown.src}
              style={{
                transform: showWebForm ? 'rotateX(180deg)' : '',
                filter:
                  'invert(44%) sepia(71%) saturate(5305%) hue-rotate(183deg) brightness(99%) contrast(101%)',
              }}
              alt="chevron-down"
            />
          </b>
        </div>
        {showWebForm && (
          <div>
            <ClientHubContactWebform
              track={track}
              facilityId={facilityData?.Facility_ID}
            />
          </div>
        )}
        <hr />
        <div>
          <span>
            <b>Address:</b>{' '}
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noreferrer"
              onClick={() => track('Open store directions')}
              href={`https://www.google.com/maps/search/?api=1&query=%20&query_place_id=${facilityData?.Google_PlaceID}`}
            >
              {' '}
              {Address?.Street_1}
              {Address?.Street_2}, {Address?.City} {Address?.Postal_Code}
            </a>
          </span>
          <br />

          <div style={{ paddingTop: '10px' }}>
            <b>Website:</b>{' '}
            <a
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noreferrer"
              onClick={() => track('Open store page')}
              href={`https://www.accessstorage.ca/en/self-storage/${
                facilityData?.City?.data?.attributes?.Slug
                  ? `${facilityData?.City?.data?.attributes?.Slug}/`
                  : ''
              }/${facilityData?.Slug}/`}
            >
              Access Storage – {facilityData?.Title || ''}
            </a>{' '}
            <br />
          </div>

          <div
            onClick={() => setExpandOfficeHours(!expandOfficeHours)}
            style={{ paddingTop: '10px' }}
          >
            <b>
              {' '}
              Office hours{' '}
              <img
                src={chevronDown.src}
                style={{
                  transform: expandOfficeHours ? 'rotateX(180deg)' : '',
                }}
                alt="chevron-down"
              />{' '}
            </b>
          </div>
          <div
            style={{
              display: expandOfficeHours ? 'block' : 'none',
              paddingLeft: '10px',
            }}
          >
            <div>Monday: {officeHours('Monday')}</div>
            <div>Tuesday: {officeHours('Tuesday')}</div>
            <div>Wednesday: {officeHours('Wednesday')}</div>
            <div>Thursday: {officeHours('Thursday')}</div>
            <div>Friday: {officeHours('Friday')}</div>
            <div>Saturday: {officeHours('Saturday')}</div>
            <div>Sunday: {officeHours('Sunday')}</div>
            <br />
          </div>

          <div
            onClick={() => setExpandGateHours(!expandGateHours)}
            style={{ paddingTop: '10px' }}
          >
            <b>
              {' '}
              Gate hours{' '}
              <img
                src={chevronDown.src}
                style={{ transform: expandGateHours ? 'rotateX(180deg)' : '' }}
                alt="chevron-down"
              />{' '}
            </b>
          </div>
          <div
            style={{
              display: expandGateHours ? 'block' : 'none',
              paddingLeft: '10px',
            }}
          >
            <div>Monday: {gateHours('Monday')}</div>
            <div>Tuesday: {gateHours('Tuesday')}</div>
            <div>Wednesday: {gateHours('Wednesday')}</div>
            <div>Thursday: {gateHours('Thursday')}</div>
            <div>Friday: {gateHours('Friday')}</div>
            <div>Saturday: {gateHours('Saturday')}</div>
            <div>Sunday: {gateHours('Sunday')}</div>
            <br />
          </div>
        </div>
      </div>
      <hr />
      <br />
    </div>
  );
};

export default ClientHubContact;
